<style scoped lang="scss" type="text/scss">
    $padding: 1.5rem;

    .sidebar-container {
        background-color: #111;
        width: 14rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        border-top: 1px solid rgba(200, 200, 200, .1);

        .menu-container {
            flex: 1;
            width: 100%;
            overflow: auto;
            margin-top: 1.5rem;

            .menu-wrap {
                width: 100%;
                overflow: hidden;
                transition: all .2s;

                &.folding {
                    height: 2.5rem !important;
                }

                .menu-item {
                    color: #EEE;
                    box-sizing: border-box;
                    width: 100%;
                    height: 2.5rem;
                    padding: 0 $padding;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    transition: all .2s;

                    &.master-item {
                        font-size: .9rem;
                    }

                    &.slave-item {
                        font-size: .8rem;
                    }

                    &:hover {
                        cursor: pointer;
                    }

                    &:hover, &.active {
                        color: #333;
                        font-weight: bold;
                        background-color: #DDD;
                    }
                }

                .icon {
                    width: 1rem;
                    text-align: center;

                    &.left-icon {
                        margin-right: .8rem;
                    }
                }

                .text {
                    flex: 1;
                }
            }
        }
    }
</style>

<template>
    <div class="sidebar-container">
        <div class="menu-container">
            <div class="menu-wrap" v-for="(item, index) in configSync" v-if="item.permission !== false"
                 :key="index"
                 :class="{folding: item.active === false}"
                 :style="{height: (item.valid_children_length + 1) * 2.5 + 'rem'}">
                <div class="master-item menu-item" @click="toggle(item)">
                    <i class="icon left-icon" v-html="item.icon"></i>
                    <span class="text">{{ item.title }}</span>
                    <i class="icon" v-html="item.active === true ? '&#xe668;' : '&#xe84a;'"></i>
                </div>
                <div class="slave-item menu-item" v-for="(subItem, index) in item.children"
                     :key="index"
                     v-if="subItem.permission !== false"
                     :class="{'active': currentRouteName === subItem.route_name ||
                     (subItem.related_route_names !== undefined && subItem.related_route_names.indexOf(currentRouteName) > -1) }"
                     @click="redirect(subItem.route_name)">
                    <i class="icon left-icon"></i>
                    <el-badge class="sidebar-badge" :is-dot="subItem.notice === true">
                        <span class="text">{{ subItem.title }}</span>
                    </el-badge>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';

    export default {
        name: '',
        props: {
            config: {
                type: Array,
                default: () => []
            }
        },
        watch: {
            config: {
                immediate: true,
                deep: true,
                handler (config) {
                    this.configSync = _.cloneDeep(config);
                }
            }
        },
        data () {
            return {
                configSync: []
            };
        },
        computed: {
            currentRouteName () {
                return this.$route.name;
            }
        },
        methods: {
            toggle (item) {
                item.active = !item.active;
            },
            redirect (routeName) {
                this.$router.push({
                    name: routeName
                });
            }
        }
    };
</script>
